import { render } from "./micuenta.vue?vue&type=template&id=5f988584&scoped=true"
import script from "./micuenta.vue?vue&type=script&lang=js"
export * from "./micuenta.vue?vue&type=script&lang=js"

import "./micuenta.vue?vue&type=style&index=0&id=5f988584&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f988584"]])

export default __exports__